import {TKey, useTranslation} from '@/translations/i18n'
import {Badge} from '@/components/ui/badge/Badge'
import {ConversationEntityType} from '@/features/conversations/types'

type ConversationEntityBadgeProps = {
    entityType: ConversationEntityType
}

const entityBadge = {
    project: 'commons:projects',
    treatment_request: 'commons:treatment_request',
    medical_record_report: 'global_search:medical_record'
} as const satisfies Record<ConversationEntityType, TKey>

export const ConversationEntityBadge = ({entityType}: ConversationEntityBadgeProps) => {
    const {t} = useTranslation()
    return (
        <Badge variant="neutral" size="sm" shape="rectangle">
            {t(entityBadge[entityType], {count: 2})}
        </Badge>
    )
}
